export enum MemberRegistrationMode {
    RegistrationForm,
    EmailValidation,
    MFAConfigForm,
    MFAValidation,
    CreatePassword,
    MemberSelect
}